'use client';
import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  Tooltip,
  ResponsiveContainer,
  Legend,
} from 'recharts';

const categoryData = [
  { name: 'Maid Rental', value: 487, color: 'hsl(211, 65%, 28%)' },
  { name: 'Apartments', value: 312, color: 'hsl(40, 65%, 55%)' },
  { name: 'Hospitality', value: 248, color: 'hsl(142, 71%, 35%)' },
  { name: 'Other', value: 89, color: 'hsl(215, 15%, 70%)' },
];

const CustomTooltip = ({ active, payload }: {
  active?: boolean;
  payload?: Array<{ name: string; value: number; payload: { color: string } }>;
}) => {
  if (active && payload && payload.length) {
    const total = categoryData.reduce((s, d) => s + d.value, 0);
    const pct = ((payload[0].value / total) * 100).toFixed(1);
    return (
      <div className="bg-white border border-border rounded-xl shadow-modal px-4 py-3 text-sm">
        <p className="font-semibold text-foreground">{payload[0].name}</p>
        <p className="font-bold tabular-nums" style={{ color: payload[0].payload.color }}>
          {payload[0].value} bookings
        </p>
        <p className="text-muted-foreground text-xs">{pct}% of total</p>
      </div>
    );
  }
  return null;
};

export default function BookingCategoryChart() {
  const total = categoryData.reduce((s, d) => s + d.value, 0);

  return (
    <div className="bg-white rounded-xl border border-border shadow-card p-6 h-full flex flex-col">
      <div className="mb-4">
        <h3 className="font-display font-semibold text-base text-foreground">Bookings by Category</h3>
        <p className="text-xs text-muted-foreground mt-0.5">{total} total bookings this month</p>
      </div>

      <div className="flex-1 flex items-center justify-center">
        <ResponsiveContainer width="100%" height={220}>
          <PieChart>
            <Pie
              data={categoryData}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={90}
              paddingAngle={3}
              dataKey="value"
            >
              {categoryData.map((entry, index) => (
                <Cell key={`cell-cat-${index}`} fill={entry.color} stroke="none" />
              ))}
            </Pie>
            <Tooltip content={<CustomTooltip />} />
          </PieChart>
        </ResponsiveContainer>
      </div>

      {/* Legend */}
      <div className="space-y-2 mt-2">
        {categoryData.map((item) => (
          <div key={`legend-${item.name}`} className="flex items-center justify-between">
            <div className="flex items-center gap-2">
              <span className="w-2.5 h-2.5 rounded-full flex-shrink-0" style={{ backgroundColor: item.color }} />
              <span className="text-sm text-muted-foreground">{item.name}</span>
            </div>
            <div className="flex items-center gap-2">
              <span className="text-sm font-semibold text-foreground tabular-nums">{item.value}</span>
              <span className="text-xs text-muted-foreground tabular-nums">
                {((item.value / total) * 100).toFixed(0)}%
              </span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}